import { render } from "./HeaderSlide.vue?vue&type=template&id=5ed67045&scoped=true"
import script from "./HeaderSlide.vue?vue&type=script&lang=js"
export * from "./HeaderSlide.vue?vue&type=script&lang=js"

import "./HeaderSlide.vue?vue&type=style&index=0&id=5ed67045&scoped=true&lang=css"

import exportComponent from "/var/www/site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ed67045"]])

export default __exports__